import { Link, useLocation } from 'react-router-dom';
import { useMenu } from '../../context/MenuContext';
import { useIsMobile } from '../../hooks/useMediaQuery';
import { useUserPermissions } from '../../hooks/useUserPermissions';
import { useCafeteriaSelection } from '../../context/CafeteriaSelectionContext';

// Componente de ícone SVG para o menu
const MenuIcon = ({ icon, className = "w-5 h-5" }: { icon: string; className?: string }) => {
  const icons: { [key: string]: React.ReactElement } = {
    dashboard: (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    info: (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    ),
    products: (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
      </svg>
    ),
    reviews: (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.118 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
      </svg>
    ),
    legal: (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
    users: (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
      </svg>
    ),
    business: (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a2.5 2.5 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    ),
    places: (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    ),
    torrefacoes: (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
      </svg>
    ),
    routes: (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A2 2 0 013 15.486V7.514a2 2 0 011.106-1.79L9 3m0 17l6-3m-6 3V3m6 17l4.894-2.447A2 2 0 0021 16.486V8.514a2 2 0 00-1.106-1.79L15 4m0 16V4m0 0L9 3" />
      </svg>
    ),
    events: (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
    settings: (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    hours: (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    posts: (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
    notifications: (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-5 5v-5zM4.828 7l2.586 2.586a2 2 0 002.828 0L12.828 7H4.828zM4 5h16a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V7a2 2 0 012-2z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 2a2 2 0 00-2 2v2a2 2 0 002 2h0a2 2 0 002-2V4a2 2 0 00-2-2z" />
      </svg>
    ),
    coupons: (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
      </svg>
    ),
  };

  return icons[icon] || <div className={className} />;
};

const Sidebar = () => {
  const location = useLocation();
  const { isMenuOpen, closeMenu, toggleMenu } = useMenu();
  const isMobile = useIsMobile();
  const permissions = useUserPermissions();
  const { 
    accessibleCafeterias, 
    currentCafeteria, 
    selectCafeteria, 
    isLoading, 
    error 
  } = useCafeteriaSelection();
  
  const { 
    canManageLegal, 
    canManageSystemUsers, 
    canManagePlaces
  } = permissions;

  const handlePlaceChange = async (placeId: string) => {
    const success = await selectCafeteria(placeId);
    if (success) {
      console.log('Cafeteria selecionada com sucesso:', placeId);
    } else {
      console.error('Erro ao selecionar cafeteria:', error);
    }
  };

  // Aguardar carregamento das permissões antes de renderizar o menu
  if (canManageLegal === undefined || canManageSystemUsers === undefined || canManagePlaces === undefined) {
    return (
      <aside className="fixed left-0 top-0 z-40 h-screen bg-white border-r border-neutral-200 flex items-center justify-center">
        <div className="text-neutral-500">Carregando...</div>
      </aside>
    );
  }

  const navItems = [
    {
      name: 'Dashboard',
      path: '/dashboard',
      icon: 'dashboard',
      visible: !canManageSystemUsers,
      category: 'Visão Geral'
    },
    {
      name: 'Informações',
      path: '/place-info',
      icon: 'info',
      visible: !canManageSystemUsers,
      category: 'Visão Geral'
    },
    {
      name: 'Produtos',
      path: '/products',
      icon: 'products',
      visible: !canManageSystemUsers,
      category: 'Gerenciamento'
    },
    {
      name: 'Avaliações',
      path: '/reviews',
      icon: 'reviews',
      visible: !canManageSystemUsers,
      category: 'Gerenciamento'
    },
    {
      name: 'Horários',
      path: '/hours',
      icon: 'hours',
      visible: !canManageSystemUsers,
      category: 'Gerenciamento'
    },
    {
      name: 'Eventos',
      path: '/cafeteria/events',
      icon: 'events',
      visible: !canManageSystemUsers,
      category: 'Gerenciamento'
    },
    {
      name: 'Posts',
      path: '/posts',
      icon: 'posts',
      visible: true, // Disponível para PlaceAdmin e SuperAdmin
      category: 'Gerenciamento'
    },
    {
      name: 'Push Notifications',
      path: '/notifications',
      icon: 'notifications',
      visible: canManageSystemUsers,
      category: 'Administração'
    },
    {
      name: 'Todos os Eventos',
      path: '/events',
      icon: 'events',
      visible: canManageSystemUsers,
      category: 'Administração'
    },
    {
      name: 'Documentos Legais',
      path: '/legal',
      icon: 'legal',
      visible: canManageLegal,
      category: 'Administração'
    },
    {
      name: 'Usuários do App',
      path: '/users',
      icon: 'users',
      visible: canManageSystemUsers,
      category: 'Administração'
    },
    {
      name: 'Usuários Empresariais',
      path: '/business-users',
      icon: 'business',
      visible: canManageSystemUsers,
      category: 'Administração'
    },
    {
      name: 'Gerenciar Cafeterias',
      path: '/places',
      icon: 'places',
      visible: canManagePlaces,
      category: 'Administração'
    },
    {
      name: 'Gerenciar Torrefações',
      path: '/torrefacoes',
      icon: 'torrefacoes',
      visible: canManagePlaces,
      category: 'Administração'
    },
    {
      name: 'Roteiros',
      path: '/routes',
      icon: 'routes',
      visible: canManageSystemUsers,
      category: 'Administração'
    },
    {
      name: 'Categorias',
      path: '/categories',
      icon: 'products',
      visible: canManageSystemUsers,
      category: 'Administração'
    },
    {
      name: 'Coffee Profiles',
      path: '/coffee-profile-levels',
      icon: 'users',
      visible: canManageSystemUsers,
      category: 'Administração'
    },
    {
      name: 'Características',
      path: '/characteristics',
      icon: 'settings',
      visible: canManageSystemUsers,
      category: 'Administração'
    },
    {
      name: 'Cupons de Desconto',
      path: '/coupons',
      icon: 'coupons',
      visible: canManageSystemUsers,
      category: 'Administração'
    },
    {
      name: 'Avaliações CoffeeIn',
      path: '/super-admin/coffeein-reviews',
      icon: 'reviews',
      visible: canManageSystemUsers,
      category: 'Administração'
    },
    {
      name: 'Configurações',
      path: '/settings',
      icon: 'settings',
      visible: true,
      category: 'Sistema'
    },
  ];

  // Filtrar itens baseado na visibilidade
  const visibleNavItems = navItems.filter(item => item.visible);

  // Agrupar itens por categoria
  const groupedItems = visibleNavItems.reduce((acc, item) => {
    if (!acc[item.category]) {
      acc[item.category] = [];
    }
    acc[item.category].push(item);
    return acc;
  }, {} as { [key: string]: typeof visibleNavItems });

  const handleNavClick = () => {
    if (isMobile) {
      closeMenu();
    }
  };

  return (
    <>
      {/* Overlay para fechar o menu no mobile */}
      {isMenuOpen && isMobile && (
        <div
          className="fixed inset-0 backdrop-blur-sm z-30"
          onClick={closeMenu}
          aria-hidden="true"
        />
      )}
      
      <aside 
        className={`fixed left-0 top-0 z-40 h-screen bg-white border-r border-neutral-200 transition-all duration-300 ease-in-out flex flex-col ${
          isMobile
            ? isMenuOpen 
              ? 'translate-x-0 w-80' 
              : '-translate-x-full w-80'
            : isMenuOpen 
              ? 'w-80' 
              : 'w-20'
        }`}
        aria-label="Menu de navegação"
      >
        {/* Header do Sidebar com Logo */}
        <div className={`${!isMenuOpen && !isMobile ? 'p-4' : 'p-6'} border-b border-neutral-100`}>
          <div className="flex items-center justify-center">
            <div className="p-3">
              <img 
                src="/logo-coffeein.png" 
                alt="Logo CoffeeIn" 
                className={`object-contain ${!isMenuOpen && !isMobile ? 'w-12 h-12' : 'w-32 h-16'}`}
              />
            </div>
          </div>
        </div>

        {/* Seletor de Cafeteria */}
        {isMenuOpen && (
          <div className="px-6 py-4 border-b border-neutral-100">
            <div className="mb-3">
              <div className="relative">
                {isLoading ? (
                  <div className="w-full h-10 bg-neutral-200 rounded-xl animate-pulse"></div>
                ) : error ? (
                  <div className="text-error-600 text-sm p-2 bg-error-50 rounded-lg">
                    Erro ao carregar cafeterias: {error}
                  </div>
                ) : (
                  <select 
                    value={currentCafeteria?.id || ''}
                    onChange={(e) => handlePlaceChange(e.target.value)}
                    className="w-full appearance-none bg-white border-2 border-neutral-200 rounded-xl px-4 py-2.5 pr-10 text-sm font-medium text-neutral-700 focus:ring-2 focus:ring-coffee-500 focus:border-coffee-500 transition-all duration-200 cursor-pointer hover:border-neutral-300"
                    disabled={accessibleCafeterias.length === 0}
                  >
                    {accessibleCafeterias.length === 0 ? (
                      <option value="">Nenhuma cafeteria disponível</option>
                    ) : (
                      accessibleCafeterias.map((place) => (
                        <option key={place.id} value={place.id}>
                          {place.name} - {place.city}, {place.state}
                        </option>
                      ))
                    )}
                  </select>
                )}
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <svg className="w-4 h-4 text-neutral-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>
            </div>
            
            {/* Nome da Cafeteria Selecionada */}
            {/* {currentCafeteria && (
              <div className="bg-coffee-50 rounded-xl p-3 border border-coffee-200">
                <h2 className="text-lg font-bold text-coffee-900">
                  {currentCafeteria.name}
                </h2>
                <p className="text-sm text-coffee-700">
                  {currentCafeteria.city}, {currentCafeteria.state}
                </p>
                <div className="flex items-center justify-between mt-2">
                  <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                    currentCafeteria.isActive 
                      ? 'bg-success-100 text-success-800' 
                      : 'bg-warning-100 text-warning-800'
                  }`}>
                    {currentCafeteria.isActive ? 'Ativa' : 'Inativa'}
                  </span>
                  <span className="text-xs text-coffee-600 font-medium capitalize">
                    {currentCafeteria.role.toLowerCase().replace('_', ' ')}
                  </span>
                </div>
              </div>
            )} */}
          </div>
        )}
        
        {/* Navegação */}
        <nav className={`${!isMenuOpen && !isMobile ? 'px-2' : 'px-4'} py-6 flex-1 overflow-y-auto scrollbar-thin`} aria-label="Navegação principal">
          <div className="space-y-8">
            {Object.entries(groupedItems).map(([category, items]) => (
              <div key={category}>
                {isMenuOpen && (
                  <h3 className="px-4 mb-3 text-xs font-semibold text-neutral-500 uppercase tracking-wider">
                    {category}
                  </h3>
                )}
                <ul className="space-y-1">
                  {items.map((item) => (
                    <li key={item.path}>
                      <Link
                        to={item.path}
                        onClick={handleNavClick}
                        className={`nav-item ${
                          location.pathname === item.path ? 'nav-item-active' : ''
                        } ${!isMenuOpen && !isMobile ? 'justify-center px-2' : ''}`}
                        title={!isMenuOpen && !isMobile ? item.name : undefined}
                        aria-current={location.pathname === item.path ? 'page' : undefined}
                      >
                        <MenuIcon 
                          icon={item.icon} 
                          className={`${!isMenuOpen && !isMobile ? 'w-6 h-6' : 'w-5 h-5'} ${
                            location.pathname === item.path ? 'text-coffee-600' : 'text-neutral-500'
                          }`} 
                        />
                        {isMenuOpen && (
                          <span className="ml-3 font-medium">{item.name}</span>
                        )}
                        {!isMenuOpen && !isMobile && (
                          <span className="sr-only">{item.name}</span>
                        )}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </nav>

        {/* Footer do Sidebar */}
        <div className={`${!isMenuOpen && !isMobile ? 'p-2' : 'p-4'} border-t border-neutral-100`}>
          <div className={`flex items-center ${!isMenuOpen && !isMobile ? 'justify-center' : 'justify-between'}`}>
            {isMenuOpen && (
              <div className="text-xs text-neutral-500">
                <p>Versão 1.0.3</p>
                <p>© 2025 CoffeeIn Club</p>
              </div>
            )}
            <button
              onClick={toggleMenu}
              className={`p-2 rounded-xl hover:bg-neutral-100 transition-colors duration-200 ${
                !isMenuOpen && !isMobile ? 'w-full' : ''
              }`}
              title={isMenuOpen ? "Recolher menu" : "Expandir menu"}
            >
              <svg className="w-5 h-5 text-neutral-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar; 
